<template>
  <div class="row">
    <header-servico
      tipo="Histórico de Acolhimentos"
      :loading="loading"
      :familia="familia.id"
    />
    <load v-if="loading" message="Carregando Acolhimentos da Família" />
    <div v-else class="col-md-12">
      <!--Tabela-->
      <div class="row">
        <sidebar-servicos active="acolhimentos" />

        <div class="col-md-9">
          <div class="row">
            <div class="col-md-12">
              <header-familia :item="familia" />
            </div>
          </div>
          <div class="card mb-0 shadow">
            <div class="card-body">
              <div class="tab-content">
                <div
                  v-if="!cadastrar"
                  class="animate__animated animate__fadeIn"
                >
                  <div class="row">
                    <div class="col-12">
                      <div
                        class="d-flex align-items-center justify-content-between mb-4"
                      >
                        <div>
                          <button
                            class="btn btn-primary"
                            @click="cadastrar = true"
                          >
                            <i class="fas fa-plus-square" />
                            {{ $t("Cadastrar") }}
                          </button>
                        </div>
                        <div>
                          <div class="d-flex align-items-start">
                            <div class="mr-2" style="min-width: 180px">
                              <select
                                class="form-control"
                                v-model="filtroStatus"
                                @change="getItens"
                              >
                                <option value="">Todos</option>
                                <option value="1">ATIVO</option>
                                <option value="2">INATIVO</option>
                                <option value="3">EGRESSO</option>
                              </select>
                            </div>

                            <div class="input-group mb-3">
                              <b-input
                                :placeholder="$t('Type to search')"
                                class="form-control search-input"
                                type="text"
                                v-model="search"
                                v-on:change="getItens"
                                aria-describedby="input-search"
                              />
                              <div class="input-group-append" role="button">
                                <span class="input-group-text" id="input-search">
                                  <i class="fas fa-search search-icon" />
                                </span>
                                <b-button variant="outline-dark" @click="print()">
                                  <i class="fas fa-print"></i>
                                </b-button>
                                <b-button
                                  variant="outline-dark"
                                  @click="exportar()"
                                  :title="$t('Exportar')"
                                  v-b-tooltip.hover
                                >
                                  <i class="fas fa-file-excel"></i>
                                </b-button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <load mode="table" v-if="loadingItens" />
                    <div class="col-12" v-else>
                      <span>
                        <a
                          v-if="!showName"
                          @click.prevent="mostrarNome"
                          href="#"
                          ><i class="fas fa-eye"></i> Mostrar Nome de
                          Registro</a
                        >
                        <a v-else @click.prevent="ocultarNome" href="#"
                          ><i class="fas fa-eye-slash"></i> Ocultar Nome de
                          Registro</a
                        >
                      </span>
                      <print-content>
                        <b-table
                          :fields="[
                            {
                              key: 'protocolo',
                              label: $t('Detalhes'),
                            },
                            {
                              key: 'cadastrado',
                              label: $t('Data'),
                            },
                            {
                              key: 'actions',
                              label: '',
                              class: 'text-right',
                              thStyle: {
                                width: '95px',
                                minWidth: '95px',
                              },
                            },
                          ]"
                          :items="itemList"
                          :responsive="true"
                          striped
                          hover
                          show-empty
                          small
                          outlined
                          stacked="md"
                          table-class="mb-3"
                        >
                          <template v-slot:cell(protocolo)="data">
                            Usuário(s):<br />
                            <ul>
                              <li
                                v-for="pessoa in data.item.pessoas_objetos"
                                :key="pessoa.id"
                              >
                                <b v-if="!pessoa.nome_social">{{
                                  pessoa.nome_completo
                                }}</b>
                                <b v-else>
                                  {{ pessoa.nome_social }} ( N.R.: )
                                  <span v-if="showName">
                                    {{ pessoa.nome_completo }}</span
                                  >
                                </b>
                              </li>
                            </ul>
                            Protocolo:
                            <b>{{ data.item.protocolo }}</b>
                            <br />
                            Status:
                            <b>{{ data.item.status_nome }}</b>
                            <br />
                            Unidade Acolhedora:
                            <b v-if="data.item.unidade_acolhedora">{{
                              data.item.unidade_acolhedora.nome
                            }}</b>
                            <b v-else>
                              {{ data.item.outra_unidade }}
                            </b>
                            <br />
                            Técnico autor:
                            <b>{{ data.item.autor }}</b>
                            <br />
                            Unidade:
                            <b v-if="data.item.unidade">{{
                              data.item.unidade.nome
                            }}</b>
                          </template>
                          <template v-slot:cell(cadastrado)="data">
                            {{ data.item.cadastrado }}
                          </template>
                          <template v-slot:cell()="data">
                            <b-button
                              :title="$t('Editar')"
                              :to="
                                '/dashboard/familia/acolhimentos/edit/' +
                                data.item.id +
                                '?familia_id=' +
                                data.item.familia_id
                              "
                              class="px-2 mb-0"
                              size="xs"
                              type="button"
                              v-b-tooltip.hover
                              variant="success"
                              v-if="
                                user_id == data.item.user_id
                              "
                            >
                              <i class="mdi mdi-square-edit-outline" />
                            </b-button>

                            <b-button
                              :title="$t('Visualizar e Imprimir')"
                              :to="
                                '/dashboard/familia/acolhimentos/show/' +
                                data.item.id
                              "
                              class="px-2 mb-0"
                              size="xs"
                              type="button"
                              v-b-tooltip.hover
                              variant="primary"
                              v-else-if="
                                data.item.unidade_id == unidade_id &&
                                (data.item.user_role ==
                                  'Técnico(a) Administrativo(a)' ||
                                  data.item.user_role ==
                                    'Técnico(a) de Nível Médio PSB' ||
                                  data.item.user_role ==
                                    'Técnico(a) de Nível Médio PSE' ||
                                  $store.state.user.role_details.name ==
                                    'Coordenador' ||
                                  $store.state.user.role_details.name ==
                                    'Gestor(a)' ||
                                  $store.state.user.role_details.name ==
                                    'Técnico(a) de Nível Superior')
                              "
                            >
                              <i class="mdi mdi-eye" />
                            </b-button>
                          </template>
                          <template v-slot:empty="scope">
                            <div class="text-center my-5">
                              <img
                                :alt="$t('No results')"
                                class="mb-5"
                                src="/img/icons/robot.svg"
                                style="max-height: 165px"
                              />
                              <h3 class="bold">
                                {{ $t("No records found") }}
                              </h3>
                            </div>
                          </template>
                        </b-table>
                      </print-content>
                      <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                          <div class="form-group d-inline-flex mb-0">
                            <select
                              class="form-control"
                              style="width: 70px"
                              v-model="perPage"
                              v-on:change="getItens"
                            >
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                          <div class="d-inline-flex ml-2">
                            <b-pagination
                              :per-page="perPage"
                              :total-rows="pagination.total"
                              @change="changePage"
                              v-model="page"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                          <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }}
                            de
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Cadastrar
                  v-else
                  :familia="familia"
                  @voltar="cadastrar = false"
                  @reload="getItens"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cadastrar from "./Add";
export default {
  components: { Cadastrar },
  name: "Acolhimento",
  metaInfo() {
    return {
      title: this.$i18n.t("Histórico de Acolhimento"),
    };
  },
  data() {
    return {
      showName: false,
      familia: {},
      cadastrar: false,
      itemList: [],
      page: 1,
      search: "",
      filtroStatus: "",
      perPage: 10,
      loadingItens: true,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      user_id: null,
      unidade_id: null,
      referencias_recebidas: 1,
    };
  },
  mounted() {
    this.$route.query.familia_id = this.$route.params.id;
    if (typeof this.$route.query.item === "object") {
      this.familia = this.$route.query.item;
    } else {
      this.getFamilia();
    }
    this.getItens();
  },
  methods: {
    isUserInArray(tecnicos, user_id) {
      // Verifica se 'tecnicos' é um array válido e se não é undefined ou null
      return Array.isArray(tecnicos) && tecnicos.some((tecnico) => tecnico.id === user_id);
    },
    mostrarNome() {
      this.showName = true;
    },
    ocultarNome() {
      this.showName = false;
    },
    getItens() {
      this.loadingItens = true;
      axios
        .get("api/dashboard/familia/acolhimentos", {
          params: {
            id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            familia_id: this.$route.params.id,
            filtroStatus: this.filtroStatus,
          },
        })
        .then((response) => {
          this.user_id = this.$store.state.user.id;
          this.unidade_id = this.$store.state.user.tecnico.unidade_id;
          this.itemList = response.data.data;
          this.pagination = response.data.pagination;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getItens();
          } else {
            this.loadingItens = false;
          }
        })
        .catch(() => {
          this.loadingItens = false;
        });
    },
    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/familia/acolhimentos", {
          params: {
            id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            familia_id: this.$route.params.id,
            filtroStatus: this.filtroStatus,
            export: "ok",
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getItens();
      }
    },
    getFamilia() {
      axios
        .get("api/dashboard/familias/" + this.$route.params.id)
        .then((response) => {
          this.familia = response.data.data;
          this.$route.query.familia_id = this.familia.id;
          this.loading = false;
        })
        .catch(() => {
          this.$router.push("/dashboard/familias");
        });
    },
  },
};
</script>
